import {
  CPSConfig,
  CPSConfigFunctionnality,
  HistoryChartModeEnum,
  HistoryGraphModeEnum,
  HistoryGraphYModeEnum,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P00039DataRxTxIndex } from './P00039Sync';
import { Pool } from '../../../../apis/pool.api';
import { P00058InstallationFinish } from './P00058/Installation/P00058InstallationFinish';
import { P00058InstallationReset } from './P00058/Installation/P00058InstallationReset';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { FunctionParametersProductComponent } from '../../../../components/ecosystems/function-parameters-product/function-parameters-product.component';
import { P00058PompeMiseEnOeuvreInit } from './P00058/Pompe/miseenoeuvre/P00058PompeMiseEnOeuvreInit';
import { P00058InstallationPompeComponent } from './P00058/Installation/p00058-installation-pompe/p00058-installation-pompe.component';
import { P00058CardFiltrationControleComponent } from './P00058/Pompe/cards/p00058-card-filtration-controle/p00058-card-filtration-controle.component';
import { P00058CardFiltrationStatusComponent } from './P00058/Pompe/cards/p00058-card-filtration-status/p00058-card-filtration-status.component';
import { P00058PompeMiseEnOeuvreFiltrationComponent } from './P00058/Pompe/miseenoeuvre/p00058-pompe-mise-en-oeuvre-filtration/p00058-pompe-mise-en-oeuvre-filtration.component';
import { P00058PompeMiseEnOeuvreProgrammeComponent } from './P00058/Pompe/miseenoeuvre/p00058-pompe-mise-en-oeuvre-programme/p00058-pompe-mise-en-oeuvre-programme.component';
import { P00058PompeMiseEnOeuvreProliferationBacterienneComponent } from './P00058/Pompe/miseenoeuvre/p00058-pompe-mise-en-oeuvre-proliferation-bacterienne/p00058-pompe-mise-en-oeuvre-proliferation-bacterienne.component';
import { P00039 } from './P00039';
import { P00032 } from './P00032';
import { P00058PompeMiseEnOeuvrePreventionGelComponent } from './P00058/Pompe/miseenoeuvre/p00058-pompe-mise-en-oeuvre-prevention-gel/p00058-pompe-mise-en-oeuvre-prevention-gel.component';
import { P00030 } from './P00030';
import { P00058FiltrationControleComponent } from './P00058/Pompe/cps/p00058-filtration-controle/p00058-filtration-controle.component';
import { P00058FiltrationParametersComponent } from './P00058/Pompe/cps/p00058-filtration-parameters/p00058-filtration-parameters.component';
import { P00058FiltrationStatutComponent } from './P00058/Pompe/cps/p00058-filtration-statut/p00058-filtration-statut.component';

export class P00058Data {
  pvCModeFonctionnement: number = 0;

  pvCProgrammeManuel: number = 0;

  pvCProgrammeAuto: number = 0;

  pvCResetUsine: number = 0;

  pvCConfirmationOTA: number = 0;

  pvIActivationAmorcage: number = 0;

  pvIConfigurationProduit: number = 0;

  pvIConsignePompeDoconnexion: number = 0;

  pvISourceVolet: number = 0;

  pvISourceTemperature24: number = 0;

  pvISourceTemperatureHorsGel: number = 0;

  pvPUniteConsignePompe: number = 0;

  pvPTypeHorlogeEte: number = 0;

  pvPTypeHorlogeHiver: number = 0;

  pvPActivationFonction24: number = 0;

  pvPVitesseV1: number = 0;

  pvPVitesseV2: number = 0;

  pvPVitesseEcremage: number = 0;

  pvPVitesseV3: number = 0;

  pvPDureeBaignade: number = 0;

  pvPDureeEcremage: number = 0;

  pvPSeuilTemperatureHorsGel: number = 0;

  pvPSeuilTemperature24: number = 0;

  pvPDureeAmorcage: number = 0;

  pvPVitesseAmorcage: number = 0;

  pvPHorlogeSemaineEte: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  pvPHorlogeJourEteLundi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  pvPHorlogeJourEteMardi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  pvPHorlogeJourEteMercredi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  pvPHorlogeJourEteJeudi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  pvPHorlogeJourEteVendredi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  pvPHorlogeJourEteSamedi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  pvPHorlogeJourEteDimanche: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  pvPHorlogeSemaineHivers: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  pvPHorlogeJourHiversLundi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  pvPHorlogeJourHiversMardi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  pvPHorlogeJourHiversMercredi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  pvPHorlogeJourHiversJeudi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  pvPHorlogeJourHiversVendredi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  pvPHorlogeJourHiversSamedi: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  pvPHorlogeJourHiversDimanche: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  pvSEtatBouton: number = 0;

  pvSEtatVolet: number = 0;

  pvSDisponibiliteVolet: number = 0;

  pvSEtatFonctionHorsGel: number = 0;

  pvSDisponibiliteTemperatureHorsGel: number = 0;

  pvSDisponibiliteTemperature24: number = 0;

  pvSFonctionnementPompe: number = 0;

  pvSSecuriteDeconnexionProduit: number = 0;

  pvSEafPrioriteStandard: number = 0;

  pvSEafPrioriteCellule: number = 0;

  pvSEafPrioriteBoostCellule: number = 0;

  pvSEafAutoMaintienElectrolyseurStandard: number = 0;

  pvSEafAutoMaintienElectrolyseurCellule: number = 0;

  pvSEafAutoMaintienInjectionCL: number = 0;

  pvSEafAutoMaintienInjectionPh: number = 0;

  pvSEafAutoMaintienPac: number = 0;

  pvSEafPrioritePac: number = 0;

  pvSEafAutoMaintienPacWP: number = 0;

  pvSEafPrioritePacWP: number = 0;

  pvSEafAutoMaintienPacPoly: number = 0;

  pvSEafPrioritePacPoly: number = 0;

  pvSEafRedemEclairageStandard: number = 0;

  pvSEafRedemEclairageTunalble: number = 0;

  pvSEafPrioriteRobot: number = 0;

  pvSEafAutoMaintientRobot: number = 0;

  pvSEaaFiltrationVolet24: number = 0;

  pvSEaaFiltrationVolet230: number = 0;

  pvSAvertissement: number = 0;

  pvSConsigneAvertissement: number = 0;

  pvSAlarme: number = 0;

  pvSVitesseCouranteRPM: number = 0;

  pvSPuissanceDriver: number = 0;

  pvSCodeErreur: number = 0;

  pvSCourantConsomme: number = 0;

  pvSCompteurPuissanceActive: number = 0;

  pvSTempsSousTension: number = 0;

  pvSCompteurAh: number = 0;

  pvSCompteurBouton: number = 0;

  pvSConsigneHorlogeEte: number = 0;

  pvSConsigneHorlogeHivers: number = 0;

  pvSCompteRebours72: number = 0;

  pvSCompteReboursBaignade: number = 0;

  pvSCompteReboursEcremage: number = 0;

  pvSConsigneHorsGel: number = 0;

  pvSMesureTemperatureEauHorsGel: number = 0;

  pvSMesureTemperatureEau24: number = 0;

  pvSConsigne24: number = 0;

  pvSCompteReboursAmorcage: number = 0;

  pvSCompteurResetUsine: number = 0;

  pvSVitesseMaxRpm: number = 2950;

  pvSVitesseMinRpm: number = 1000;

  pvSAmorcageEnCours: number = 0;
}

export class P00058 extends IProduct {
  override deviceTableIndex: number = 27;

  override modelIdentifier?: string = 'P00058';

  override dataIdentifier?: string = 'P00058';

  override manufacturerName?: string = 'ACWA';

  data: P00058Data = new P00058Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P00058/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P00058/product_light.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P00058/product_light.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P00058;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P00058?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P00058.tuto.installation.help.title',
      helpSlides: [
        'P00058.tuto.installation.help.1',
        'P00058.tuto.installation.help.2',
        'P00058.tuto.installation.help.3',
        'P00058.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00058/installation-1_light.png',
            dark: '/assets/ecosystem/images/products/P00058/installation-1_dark.png',
          },
          text: 'P00058.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00058/installation-2_light.png',
            dark: '/assets/ecosystem/images/products/P00058/installation-2_dark.png',
          },
          text: 'P00058.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00058/installation-1_light.png',
            dark: '/assets/ecosystem/images/products/P00058/installation-1_dark.png',
          },
          text: 'P00058.tuto.update.page1',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return {
      installation: {
        pages: [
          {
            component: P00058InstallationPompeComponent,
            condition: () => {
              return true;
            },
          },
        ],
        finish: P00058InstallationFinish,
        reset: P00058InstallationReset,
      },
      controlCards: [
        { component: P00058CardFiltrationControleComponent, weight: 14 },
      ],

      statusCards: [
        { component: P00058CardFiltrationStatusComponent, weight: 14 },
      ],

      parametrages: {
        enabledUser: false,
        enabledSupport: false,

        general: {
          enabledUser: true,
          enabledSupport: true,
          component: FunctionParametersProductComponent,
        },
      },
    };
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return [EventProductFunctionnalityEnum.FILTRATION];
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality | EventProductFunctionnalityEnum,
  ): CPSConfigFunctionnality | null {
    if (
      functionnality == IProductFunctionnality.FILTRATION_VS ||
      functionnality == EventProductFunctionnalityEnum.FILTRATION
    ) {
      return {
        miseEnOeuvre: {
          pages: [
            {
              component: P00058PompeMiseEnOeuvreFiltrationComponent,
              condition: () => {
                return true;
              },
            },
            {
              component: P00058PompeMiseEnOeuvreProgrammeComponent,
              condition: () => {
                return true;
              },
            },
            {
              component:
                P00058PompeMiseEnOeuvreProliferationBacterienneComponent,
              condition: (pool: Pool) => {
                return new P00039().hasProduct(pool, new P00032()) > 0;
              },
            },
            {
              component: P00058PompeMiseEnOeuvrePreventionGelComponent,
              condition: (pool: Pool) => {
                return (
                  new P00039().hasProduct(pool, new P00032()) > 0 ||
                  new P00039().hasProduct(pool, new P00030()) > 0
                );
              },
            },
          ],
          init: P00058PompeMiseEnOeuvreInit,
        },
        controle: {
          enabledUser: true,
          enabledSupport: true,
          component: P00058FiltrationControleComponent,
        },
        parametrages: {
          enabledUser: true,
          enabledSupport: true,

          reglage: {
            enabledUser: true,
            enabledSupport: true,
            component: P00058FiltrationParametersComponent,
          },
        },
        status: {
          enabledUser: true,
          enabledSupport: true,
          component: P00058FiltrationStatutComponent,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,
            graphiques: [
              {
                title: 'P00058.parameters.historique.suivi.puissance',
                mode: HistoryGraphModeEnum.DATA,
                property: 'pvSCompteurPuissanceActive',
                aggregate: 'delta',
                yMode: HistoryGraphYModeEnum.WATT,
                yModeOptions: { min: 0, max: 12700 },
                chartMode: HistoryChartModeEnum.NORMAL,
                enabledTotal: true,
              },
            ],
          },
        },
      };
    }

    return null;
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return {
      index: P00039DataRxTxIndex.PompeVS_Controle,
      propertyName: 'pvCConfirmationOTA',
    };
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 1;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).pvIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.csv'
    );
  }
}
